import { MessageType, useAi } from '@/context/ai'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'
import { ChangeEvent, useState } from 'react'
import * as styles from './style'
import { MAX_ANONYMOUS_MESSAGES, useAnonymousChat } from '@/context/anonymousChatContext'
import { useAuth } from '@/context/auth'

const InputBox = (): JSX.Element => {
  const { dispatch: setSearchQuery } = useAi()
  const [draft, setDraft] = useState('')
  const {
    state: { user },
  } = useAuth()
  const { state } = useAnonymousChat()

  function handleOnChange(event: ChangeEvent<HTMLInputElement>): void {
    const chatText: string = event.target.value
    setDraft(chatText)
  }
  const handleSubmit = (): void => {
    if (!draft.trim()) return // Prevent submission if draft is empty
    eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_SEND_MESSAGE)
    setSearchQuery({ type: 'UPDATE', payload: { query: draft, messageType: MessageType.UserFreeText } })
    setDraft('')
  }
  const remainingMessages = MAX_ANONYMOUS_MESSAGES - state.unauthenticatedMessageCount
  const messageCountWarning = !user?.id
    ? remainingMessages > 0
      ? `${remainingMessages} message${remainingMessages !== 1 ? 's' : ''} left before login required`
      : 'You have reached the maximum number of messages. Please log in to continue.'
    : undefined
  return (
    <div className={`${styles.container}`}>
      <div className="mt-2 flex pl-5  xxl:h-[73px] rounded-[48px] w-full border-2 border-[#EAEAEF] items-center bg-[#F7F7FA] p-[2.5px]">
        <div className="flex items-center w-full">
          <input
            autoComplete="off"
            placeholder="Ask Helen"
            type="text"
            onChange={handleOnChange}
            value={draft}
            className="m-2 xxl:text-xl w-full border-none focus:outline-none focus:ring-0 bg-[#F7F7FA] placeholder-[#2D2D32] placeholder:text-sm xxl:placeholder:text-xl"
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleSubmit()
              }
            }}
          />
        </div>
        <button
          className="bg-secondary px-4 py-2 rounded-[40px] text-sm font-semibold text-white h-10 w-20 xxl:h-16 xxl:w-[120px] xxl:text-xl"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
      {messageCountWarning && <div className={`${styles.disclaimer} text-red-500`}>{messageCountWarning}</div>}
    </div>
  )
}

export default InputBox
